import CheckInDetailsSlider from './CheckInDetailsSlider';

export default CheckInDetailsSlider;
